export namespace MLAINS {
    export interface LeadsMLAIScore {
        score?: number;
        differenceFromLastScore?: number;
        lastUpdatedDate?: Date;
        grade?: string;
        graphIconName?: string;
        differenceFromLastScoreText?: string;
        featureScore: {difference: number, name: string}[];
        otherFactors: {text: string, available: boolean}[];
        staticFactors: {feature: string, name: string, text: 'Negative'|'Positive', value: string}[];
    }

    export interface OpportunityMLAIScore {
        score?: number;
        differenceFromLastScore?: number;
        lastUpdatedDate?: Date;
        grade?: string;
        graphIconName?: string;
        differenceFromLastScoreText?: string;
        featureScore: {difference: number, name: string}[];
        otherFactors: {text: string, available: boolean}[];
        staticFactors: {feature: string, name: string, text: 'Negative'|'Positive', value: string}[];
    }

    export const MLAIScoreImprovingIconModel = {
        improving: 'improving.png',
        steady: 'steady.png',
        down: 'down.png',
    }

    export const LeadsMLAIScoreConstantText = {
        leadScoringInfo: `Lead scoring gives insights into the probability of a lead turning into a qualified prospect. These scores are generated through an automatic comparison of a lead's attributes with those of leads previously deemed qualified.`,
        accountScoringInfo: ``,
        opportunityScoringInfo: `Opportunity Scoring provides insights into the likelihood of a sales opportunity resulting in a win. Scores are calculated based on criteria like engagement level, deal size, and comparison with similar past opportunities.`,
        leadGradeInfo: `Lead grading ranks leads based on their fit to an ideal customer profile.`,
        accountGradeInfo: ``,
        opportunityGradeInfo: `Opportunity Grading ranks opportunities according to how closely they align with an ideal sales scenario. This grading helps focus efforts on the most strategically valuable deals.`,
    }
}
